var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCubicles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.8,7.7c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S24.4,7.7,22.8,7.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 8.5,
    fill: "#505050",
    width: 1.8,
    height: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M24.7,14.3c-2.8,0.1-3.3,4-3.4,5.8h11.1C31.6,18.1,29.4,14.1,24.7,14.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#505050",
    points: "4,37.3 41,37.3 41,35.2 36.4,35.2 36.4,21.4 8.8,21.4 8.8,35.2 4,35.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M20.5,20.1c0-0.9-0.7-1.7-1.7-1.7c-0.1,0-0.1,0-0.2,0c-0.9-0.1-1.8,0.6-1.9,1.5c0,0.1,0,0.1,0,0.2H20.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubicles);
export default __webpack_public_path__ + "static/media/cubicles.69b159fbe8c494e52690c1569bbb00d5.svg";
export { ForwardRef as ReactComponent };